const PASSWORD_SETUP_PARAM = 'password_setup';
const PASSWORD_SETUP_TYPES = new Set(['invitation', 'reset']);
const PASSWORD_SETUP_ALIASES = new Map([
  ['invite', 'invitation'],
  ['recovery', 'reset'],
]);

function normalizePasswordSetupType(value) {
  if (PASSWORD_SETUP_TYPES.has(value)) {
    return value;
  }

  return PASSWORD_SETUP_ALIASES.get(value) || null;
}

export function buildPasswordSetupRedirect(reason) {
  const normalizedReason = normalizePasswordSetupType(reason) || 'reset';
  const url = new URL('/', window.location.origin);

  url.searchParams.set(PASSWORD_SETUP_PARAM, normalizedReason);

  return url.toString();
}

export function getPasswordSetupReasonFromUrl() {
  const url = new URL(window.location.href);
  const explicitReason = url.searchParams.get(PASSWORD_SETUP_PARAM);
  const explicitType = normalizePasswordSetupType(explicitReason);

  if (explicitType) {
    return explicitType;
  }

  const hashParameters = new URLSearchParams(
    url.hash.replace(/^#/, '')
  );
  const tokenType =
    url.searchParams.get('type') ||
    hashParameters.get('auth') ||
    hashParameters.get('type');

  return normalizePasswordSetupType(tokenType);
}

export function getPasswordSetupTokenFromUrl() {
  const url = new URL(window.location.href);
  const hashParameters = new URLSearchParams(
    url.hash.replace(/^#/, '')
  );

  return url.searchParams.get('token') || hashParameters.get('token') || '';
}
